import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent implements OnInit {
  title: string;
  message: string;
  actionMessage: string;
  color: 'warn' | 'info';

  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.title = (data || {}).title || 'Attention';
    this.message = (data || {}).message || 'Are you sure you want to perform this action?';
    this.actionMessage = (data || {}).actionMessage || 'Yes';
    this.color = (data || {}).color || 'info';
  }

  ngOnInit() {}
}
